<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <el-form class="searchForm" ref="form" :model="form" label-width="90px" style="margin-top: 20px">
            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item label="支付时间">
                <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期"
                 v-model="form.payTimeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item label="支付金额">
                <el-input-number v-model="numBegin" controls-position="right" :min="0"></el-input-number>
                -
                <el-input-number v-model="numEnd" controls-position="right"  :max="50000"></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item label="支付编号">
                <el-input placeholder="模糊检索" v-model="form.paySn"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item label="稿件标题">
                <el-input placeholder="模糊检索" v-model="form.title"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item label="稿件作者">
                <el-input placeholder="模糊检索" v-model="form.authorName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>

      <div style="padding: 20px 0">
        <el-button type="primary" :disabled="!flag" @click="exportXLS">导出记录</el-button>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" @select-all="selAll" @selection-change="selChange" stripe style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="50"></el-table-column>

            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3 style="display:inline">{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="authorName" label="作者"></el-table-column>
            <el-table-column prop="contactTelephone" label="联系电话"></el-table-column>

            <el-table-column prop="orderSn" label="订单编号"></el-table-column>
             <el-table-column prop="paySn" label="支付编号"></el-table-column>
            <el-table-column prop="payAmount" label="支付金额"></el-table-column>
            <el-table-column prop="payTime" align="center" label="支付时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.payTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="payType" label="支付方式">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.payType == 1">线上支付</el-tag>
                <el-tag type="warning" v-else-if="scope.row.payType == 2">线下支付</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="total,sizes,prev, pager, next,jumper" 
        :total="total" :page-sizes="[10,20,30,50,100]" :page-size="pageSize" 
        :current-page="curPage"
        @size-change="pageSizeChange"
        @current-change="pageChange"> </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import financeApi from "@/api/finance"
import attachUtil from "@/utils/attachUtil"
export default {
  components: { PageHeader },
  data() {
    return {
      f_type: "1",
      headLinks: [{ path: "", title: "收款记录" }],
      form: {
        authorName: "",
        checkStatus: -1,
        payAmountRange: [0,50000],
        paySn: "",
        payTimeRange: [],
        payType: -1,
        title: "",
        orderType: -1,
      },
      flag: false,
      numBegin:0,
      numEnd:50009,

      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
    }
  },

  watch:{
    numBegin(val){
      this.form.payAmountRange[0] = val;
    },
    numEnd(val){
      this.form.payAmountRange[1] = val;
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.tableData = []
      financeApi.getPayedList(this.curPage, this.pageSize, this.form).then((res) => {
        this.tableData = res.rows;
        this.total = res.total;
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    

    exportXLS() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.payId)
      })

      financeApi.exportXLSForPayedList(ids).then((res) => {
        if (res.type!='application/octet-stream') {
          this.$alert('下载失败!', '错误', {
          confirmButtonText: '确定'});
        } else {
          attachUtil.download(res,"收款记录表.xls")
        }
      })
    },

    pageSizeChange(size){
      this.pageSize = size;
      this.pageChange(1);
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },
  },
}
</script>